import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

const removeClientAccountSite = async (userId: number, unitId: string): Promise<boolean> =>
  axios.delete(`/clientaccount/RemoveSiteFromClient?clientId=${userId}&unitId=${unitId}`).then((res) => res?.data?.result)

type Props = {
  userId: number
  unitId: string
}

export const useRemoveClientAccountSite = (notify?: boolean, onSuccess?: (data: boolean) => void, successMsg?: string, errorMsg?: string) =>
  useMutation({
    mutationKey: ['removeClientAccountSite'],
    mutationFn: ({ userId, unitId }: Props) => removeClientAccountSite(userId, unitId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(successMsg || 'Removed user.')
      }
    },
    onError: () => {
      if (notify) {
        toastError(errorMsg || 'Failed to remove user.')
      }
    },
    throwOnError: false
  })
